import { render, staticRenderFns } from "./OtherScarsTemplate.vue?vue&type=template&id=afcb8744"
import script from "./OtherScarsTemplate.vue?vue&type=script&lang=js"
export * from "./OtherScarsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports